'use strict';

const socialLogin = require('od-modules/users/social_login');
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

const loginInfoOptions = () => ({
    loginError: Odigeo.UserArea.loginError,
    firstLogin: Odigeo.UserArea.firstLogin,
    lastLoginEmailUsed: Odigeo.UserArea.loginName,
});
const noModalDialogsOptions = () => ({
    noModalDialogs: true,
});

module.exports = createWidgetFactory({
    name: 'login',
    modelClass: require('./model'),
    viewClass: require('./view'),

    options: {
        'login-header': loginInfoOptions(),
        'my-trips-login-form': Odigeo._.extend(loginInfoOptions(), noModalDialogsOptions()),
        'login-expired-login-form': noModalDialogsOptions(),
    },

    methods: {
        loginOk(data) {
            this.loginOk(data);
        },

        loginWithFacebookOk(data) {
            this.loginWithFacebookOk(data);
        },

        loginWithGoogleOk(data) {
            this.loginWithGoogleOk(data);
        },

        successfullLogin(data) {
            this.successfullLogin(data);
        },

        isLoggedInOk(data, tracking) {
            this.isLoggedInOk(data, tracking);
        },

        isLoggedInWithError() {
            this._logoutActions();
        },

        openModalLogin() {
            this.openModalLogin();
        },

        openModalLogout(data) {
            this.openModalLogout(data);
        },

        closeConnectorsLayer() {
            this.closeConnectorsLayer();
        },

        recoverPasswordOk() {
            this.recoverPasswordOk();
        },

        recoverPasswordWithError(data) {
            this.recoverPasswordError(data);
        },

        loginWithError(data) {
            this.loginWithError(data);
        },

        loginWithFacebookWithError(data) {
            this.loginWithError(Odigeo._.defaults(data, {messageError: socialLogin.socialLoginType.facebook}));
        },
        loginWithGoogleWithError(data) {
            this.loginWithError(Odigeo._.defaults(data, {messageError: socialLogin.socialLoginType.google}));
        },

        logOutOk() {
            this._logoutActions();
        },

        isUserLogged() {
            Odigeo.trigger(`${this.id}:userIsLogged`, this.model.logged);
        },

        // TODO: Decouple logic from login widget!
        goToMyTrips() {
            this.goToMyTrips();
        },
        fromDeepLinkToDetails(flow) {
            this.fromDeepLinkToDetails(flow);
        },
        // End coupling

        setLogged() {
            this.model.logged = true;
        },

        hideShowRegisterFooterLink(isVisible) {
            this.hideShowRegisterFooterLink(isVisible);
        },

        initEmbedView(button) {
            this.initEmbedView(button);
        },

        checkMembershipFastMenu(isMembership, isPendingToCollect) {
            this.checkMembershipFastMenu(isMembership, isPendingToCollect);
        },
        launchPriceMemberDisplay() {
            const action = this.model.isMembership && this.model.logged ? 'login' : 'logout';
            Odigeo.trigger('membership:priceMemberDisplay', action);
        },
        displayLoginOk(data) {
            this.displayLoginOk(data);
        },
        isLogged() {
            return this.model.logged;
        },
        isMember() {
            return this.model.isMembership;
        },
        renderCaptcha(isLoginForm) {
            this.renderCaptcha(isLoginForm);
        },
        performUserRequestIfLogged(params, notLoggedCallback) {
            this.performUserRequestIfLogged(params, notLoggedCallback);
        },
    },
});
